import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, ArrowRight } from 'lucide-react';

const SCORE_LABEL_CLASS = {
  hot: 'bg-red-100 text-red-700',
  warm: 'bg-amber-100 text-amber-700',
};
const DEFAULT_SCORE_LABEL_CLASS = 'bg-slate-100 text-slate-500';

export function HottestLeads({ leads }) {
  if (!leads?.length) return null;

  return (
    <div className="border border-slate-200 rounded-sm bg-white mb-8">
      <div className="p-4 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Flame className="w-4 h-4 text-red-500" />
          <h2 className="font-heading font-semibold text-slate-900 text-sm">Hottest Leads</h2>
        </div>
        <Link to="/leads" className="text-xs text-[#0047AB] hover:underline flex items-center gap-1">View All <ArrowRight className="w-3 h-3" /></Link>
      </div>
      <div className="divide-y divide-slate-100">
        {leads.map((lead, i) => {
          const sc = lead.score;
          const isHot = sc?.label === 'hot';
          const labelCls = SCORE_LABEL_CLASS[sc?.label] || DEFAULT_SCORE_LABEL_CLASS;
          return (
            <Link key={lead.id} to={`/leads/${lead.id}`} className="flex items-center justify-between p-3 hover:bg-slate-50 transition-colors" data-testid={`top-lead-${i}`}>
              <div className="flex items-center gap-3 min-w-0">
                <span className="w-6 h-6 bg-slate-100 rounded-sm flex items-center justify-center text-xs font-bold text-slate-500 shrink-0">{i + 1}</span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-slate-900 truncate">{lead.name}</p>
                  <p className="text-[10px] text-slate-400">{lead.company || '\u2014'} &middot; {lead.status}</p>
                </div>
              </div>
              <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-sm shrink-0 ${labelCls}`}>
                {isHot && <Flame className="w-3 h-3" />}
                {sc?.total || 0}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
